import { cn } from './cn'

/**
 * Barre de progression.
 *
 * Le handoff en fixe la forme : 6–8px de haut, rayon plein, fond `cream-warm`,
 * remplissage lavande — ou corail quand l'échéance approche. C'est le même
 * composant qui sert à l'avancement d'une capsule, au temps restant sur un
 * accompagnement et à l'atteinte d'un objectif trimestriel.
 */
export function ProgressBar({
  value,
  tone = 'lavender',
  size = 'md',
  label,
  className,
}: {
  /** Pourcentage 0–100. Les valeurs hors bornes sont ramenées dans l'intervalle. */
  value: number
  /** `alert` signale une échéance proche ou dépassée, pas une valeur basse. */
  tone?: 'lavender' | 'alert'
  size?: 'sm' | 'md'
  /** Décrit ce que mesure la barre pour les lecteurs d'écran. */
  label: string
  className?: string
}) {
  const pct = Math.min(100, Math.max(0, value))

  return (
    <div
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
      className={cn(
        'w-full overflow-hidden rounded-pill bg-cream-warm',
        size === 'md' ? 'h-2' : 'h-1.5',
        className,
      )}
    >
      <div
        className={cn(
          'h-full rounded-pill transition-[width] duration-(--dur-slow) ease-(--ease-umiros)',
          tone === 'alert' ? 'bg-alert-border' : 'bg-lavender',
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  )
}
